'use strict';

const tableTokens = (theme) => ({
    // spacing
    tableCellPadding: '16px',
    tableFirstColumCellPaddingLeft: '32px',
    // colors
    tableAlternateRowBackgroundColor: theme.palette.grey50,
});

exports.tableTokens = tableTokens;
//# sourceMappingURL=table.js.map
